// extracted by mini-css-extract-plugin
export var numberInputContainer = "_70-0";
export var startPickingButton = "_70-1";